var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLMetaIconInfo",class:_vm.classList},[_c('div',{staticClass:"LLMetaIconInfo__icon-wrapper"},[_vm._t("default")],2),_c('div',{staticClass:"LLMetaIconInfo__value-text"},[_c('span',{},[_vm._v(_vm._s(_vm.value))]),(_vm.text && _vm.showText)?_c('span',{},[_vm._v(" "+_vm._s(_vm.text))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }